import React from "react";
import { FormSectionElements, ProgramContainer } from "../../entities/formTemplateDataType";
import TableSummaryComponent from "../summary/TableSummaryComponent";
import { getRootComponent } from "../../utilities/ElementUtils";
import styled from "styled-components";
import { Heading3, spacing } from "../../theme";

const TableSummaryTitle = styled(Heading3)`
    margin-top: ${spacing.spacing5};
    margin-bottom: ${spacing.spacing3};
`;

interface Props {
    field: FormSectionElements;
    isEng: boolean;
    callbackElement: (programContainer: ProgramContainer) => void;
    handleEditButtonClick?: (field: FormSectionElements) => void;
}

const TableSummaryElementComponent: React.FC<Props> = ({ 
    field, 
    isEng, 
    callbackElement,
    handleEditButtonClick 
}) => {
    const programContainer = getRootComponent(field);
    
    const findFieldById = (fieldId: string): FormSectionElements | null => {
        for (const section of programContainer.ListOfFormSections) {
            for (const subsection of section.ListOfFormSubSections) {
                const found = subsection.ListOfFormSectionElements.find(el => el.Id === fieldId);
                if (found) return found;
                
                for (const element of subsection.ListOfFormSectionElements) {
                    if (element.subSectionList) {
                        for (const subSec of element.subSectionList) {
                            const nestedFound = subSec.ListOfFormSectionElements.find(el => el.Id === fieldId);
                            if (nestedFound) return nestedFound;
                        }
                    }
                }
            }
        }
        return null;
    };
    
    if (!field.Visible) return null;
    
    let targetFieldsData: Array<{fieldId: string; customLabel?: string}> = [];
    
    if (field.TargetFields && field.TargetFields.length > 0) {
        targetFieldsData = field.TargetFields;
    } else if (field.TargetFieldIds && field.TargetFieldIds.length > 0) {
        targetFieldsData = field.TargetFieldIds.map(id => ({
            fieldId: id,
            customLabel: undefined
        }));
    } else if (field.TargetFieldId) {
        targetFieldsData = [{
            fieldId: field.TargetFieldId,
            customLabel: undefined
        }];
    }
    
    targetFieldsData = targetFieldsData.filter(item => item.fieldId && item.fieldId.trim() !== '');
    if (targetFieldsData.length === 0) return null;
    
    const tableSummaryTitle = field.ENUTitle;
    
    return (
        <>
            {tableSummaryTitle && (
                <TableSummaryTitle styledAs="h3">
                    {tableSummaryTitle}
                </TableSummaryTitle>
            )}
            {targetFieldsData.map((targetFieldData, index) => {
                const targetField = findFieldById(targetFieldData.fieldId);
                if (!targetField) return null;
                
                const displayField = Object.create(
                    Object.getPrototypeOf(targetField),
                    Object.getOwnPropertyDescriptors(targetField)
                );
                
                if (targetFieldData.customLabel) {
                    displayField.ENUTitle = targetFieldData.customLabel;
                }
                
                return (
                    <TableSummaryComponent
                        key={`table-summary-${targetFieldData.fieldId}-${index}`}
                        field={displayField}
                        isEng={isEng}
                        withButton={true}
                        handleEditButtonClick={handleEditButtonClick}
                        callback={callbackElement}
                        hideChangeLink={field.HideChangeLink}
                    />
                );
            })}
        </>
    );
};

export default TableSummaryElementComponent;

